module.exports = __webpack_public_path__ + "788063c8111714e3759731a78f9ec570.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/GT-Walsheim-Pro-Bold.ttf
// module id = 1240
// module chunks = 0